import { addActiveLinkClass } from '../../utils';

import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
  addActiveLinkClass({
    anchorSelector: '.Footer__menu__link',
  });
});
